import { render, staticRenderFns } from "./IconTwitter.vue?vue&type=template&id=2eccdde5&scoped=true&"
import script from "./IconTwitter.vue?vue&type=script&lang=js&"
export * from "./IconTwitter.vue?vue&type=script&lang=js&"
import style0 from "./IconTwitter.vue?vue&type=style&index=0&id=2eccdde5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eccdde5",
  null
  
)

export default component.exports